/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Failed_Trainingconfig1Inputs */

const en_us2_onboarding_failed_trainingconfig1 = /** @type {(inputs: Onboarding_Failed_Trainingconfig1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It stopped while saving your training routine.`)
};

const pt_br2_onboarding_failed_trainingconfig1 = /** @type {(inputs: Onboarding_Failed_Trainingconfig1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parou ao salvar sua rotina de treino.`)
};

const es_419_onboarding_failed_trainingconfig1 = /** @type {(inputs: Onboarding_Failed_Trainingconfig1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se detuvo al guardar tu rutina de entrenamiento.`)
};

const pt_pt2_onboarding_failed_trainingconfig1 = /** @type {(inputs: Onboarding_Failed_Trainingconfig1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parou ao guardar a tua rotina de treino.`)
};

const fr_fr2_onboarding_failed_trainingconfig1 = /** @type {(inputs: Onboarding_Failed_Trainingconfig1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interrompu pendant l'enregistrement de ta routine d'entraînement.`)
};

const de_de2_onboarding_failed_trainingconfig1 = /** @type {(inputs: Onboarding_Failed_Trainingconfig1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beim Speichern deiner Trainingsroutine ist es hängen geblieben.`)
};

const it_it2_onboarding_failed_trainingconfig1 = /** @type {(inputs: Onboarding_Failed_Trainingconfig1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si è interrotto mentre salvava la tua routine di allenamento.`)
};

/**
* | output |
* | --- |
* | "It stopped while saving your training routine." |
*
* @param {Onboarding_Failed_Trainingconfig1Inputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_failed_trainingconfig1 = /** @type {((inputs?: Onboarding_Failed_Trainingconfig1Inputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Failed_Trainingconfig1Inputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_failed_trainingconfig1(inputs)
	if (locale === "es-419") return es_419_onboarding_failed_trainingconfig1(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_failed_trainingconfig1(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_failed_trainingconfig1(inputs)
	if (locale === "de-DE") return de_de2_onboarding_failed_trainingconfig1(inputs)
	if (locale === "it-IT") return it_it2_onboarding_failed_trainingconfig1(inputs)
	return en_us2_onboarding_failed_trainingconfig1(inputs)
});
export { onboarding_failed_trainingconfig1 as "onboarding.failed_trainingConfig" }